import type { LoginAndRefreshRes } from '@brickup/shared/dto'

const storage = localStorage // On RN this should be SecureStore

// Store authToken in memory to prevent XSS attacks
// On RN this should be stored in the SecureStore (or maybe not because it might be slower than memory -> tbd...)
let accessToken: string | null = null

// Retrieve tokens from storage
export const getAccessToken = () => accessToken
export const getRefreshToken = () => storage.getItem('refreshToken') // TODO: HttpOnly Cookie for Web, SecureStoree for RN
export const getDeviceId = () => storage.getItem('deviceId') // SecureStore for RN

// Save tokens to storage
export const setTokens = (tokens: LoginAndRefreshRes) => {
  accessToken = tokens.accessToken
  storage.setItem('refreshToken', tokens.refreshToken)
  storage.setItem('deviceId', tokens.deviceId)
}

export const clearStorage = () => {
  accessToken = null
  storage.clear()
}
